import { routeMap } from '../../router';
import SearchAndLoadCheck from '../NewTaxes/components/LoadingCashierCheck/LoadingCashierCheck';
import * as React from 'react';
import * as PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { property } from 'lodash';
import ChecksContainer from './ChecksContainer';

@connect(
  createStructuredSelector({
    route: property('router.route'),
  }),
)
export default class CheckPagesWrapper extends React.Component {
  static propTypes = {
    route: PropTypes.string,
  };

  render() {
    if (this.props.route === routeMap.searchAndLoadCheck) {
      return <SearchAndLoadCheck />;
    }
    if (this.props.route === routeMap.checks) {
      return <ChecksContainer />;
    }
  }
}
